import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Helmet from "react-helmet";
import * as Path from "routes/Path/index";
import { GROUPSUMMARIZATIONVIEWS } from "common/viewContent";
import BackButtom from "components/BackButtom";
const GroupSummaryDetail = () => {
  const location = useLocation();
  const [data, setData] = useState(location.state || {});
  const formatFeedbackSummary = (text) => {
    // Replace `**bold**` text with <strong> HTML tags
    text = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    // Split the text into separate paragraphs based on double line breaks
    const paragraphs = text.split("\n\n");

    return paragraphs.map((para, index) => (
      <p
        key={index}
        dangerouslySetInnerHTML={{ __html: para.replace(/\n/g, "<br/>") }}
      />
    ));
  };

  return (
    <>
      <Helmet title={GROUPSUMMARIZATIONVIEWS.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <BackButtom />
          <h1>{GROUPSUMMARIZATIONVIEWS.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.groupSummary}>
                Group Summarization
              </Link>
            </div>
            <div className="breadcrumb-item">
              {GROUPSUMMARIZATIONVIEWS.CURRENT_MODULE}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">
                    {GROUPSUMMARIZATIONVIEWS.TOP_CONTENT}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="card p-3">
            <div className="border-bottom text-center mb-3">
              <h6 className="p-2">Group Ai Summarization</h6>
            </div>
            <div className="row mb-3">
              <div className="col-lg-12 col-xl-12 col-12">
                <div className="mb-3">
                  <div className="d-flex justify-content-between  border-bottom">
                    <div>
                      {formatFeedbackSummary(data.summary)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default GroupSummaryDetail;
